import {
  BUTTON_HEIGHT,
  FONT_SIZE,
  SCALE_BY_DISPLAY_SIZE,
  TEXT_SCALE_PROPS,
} from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import styled from "styled-components";

export const Styles = styled.div<TEXT_SCALE_PROPS>`
  .ag-header-viewport {
    border-top: 1px solid #bcbcbc;
  }

  .btn-create > svg {
    transform: rotate(0deg);
  }
  .btn-group {
    justify-content: flex-start !important;
  }
  .btn-primary {
    border-radius: 8px;
    border: 0;
    background-color: #174a83;
    padding: 6px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    min-width: 60px;
    font-weight: 600;
    font-size: 15px;
    height: 32px;
    box-shadow: none;

    &:hover {
      opacity: 0.8;
    }
  }
  .ag-ltr .ag-cell {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }
  .ag-ltr .ag-cell {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]};
  }

  .ag-header {
    background-color: #4e525b !important;
    height: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "43px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "35px"
        : "29px"} !important;
    min-height: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "43px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "35px"
        : "29px"} !important;
  }

  .ag-header-cell,
  .ag-header-cell-comp-wrapper,
  .ag-header-cell:hover,
  .ag-header-cell-comp-wrapper:hover {
    background-color: transparent !important;
  }

  .ag-header-cell .floatingFilter-select {
    padding-top: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "2px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "2px"
        : "5px"} !important;
  }

  .ag-header-cell-text {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
    color: #ffffff !important;
  }
  .ag-floating-filter-input {
    height: 25px;
  }

  :where(.ant-pagination-item) {
    min-width: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "30px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "25px"
        : "22px"} !important;
    height: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "30px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "25px"
        : "22px"} !important;
    line-height: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "30px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "25px"
        : "22px"} !important;
  }
  .ant-pagination-item a {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  .ant-select-item-option-content,
  .ant-select-selection-item {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  input[type="checkbox"] {
    width: unset !important;
    transform: ${({ text_scale }) =>
      `scale(${
        SCALE_BY_DISPLAY_SIZE[text_scale || DISPLAY_SIZES.SMALL]
      })`} !important;
    height: ${({ text_scale }) =>
      `${
        Number(BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]) + 5
      }px`} !important;
  }
`;
